<template>
  <div class="cells" :class="{'cells_mobile': isMobile}">
    <div
      class="cells__wrap"
      :style="{
        'width': maxWidth+'px',
        'max-width': maxWidth+'px',
      }"
    >
      <div
        v-for="(item, key) in items"
        :key="'cell_item_' + key"
        class="cells__item"
      >
        <div class="cells__header">
          <div class="cells__title">{{ item.title }}</div>
          <div class="cells__icon-wrap">
            <div class="cells__icon-block">
              <div class="cells__icon-circle">
                <v-icon>{{ item.icon }}</v-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="cells__content">
          <div class="cells__content-wrap">
            <div
              v-for="(string, stringKey) in item.strings"
              :key="'cell_string_'+stringKey"
              class="cells__string"
            >{{ string }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {type: Array, default: () => []},
    maxWidth: {type: Number, default: 1300},
  },
}
</script>

<style lang="scss">
$cellShadow: 0 8px 40px rgba(177, 177, 178, 0.35);

.cells {
  background: #fff;
  display: flex;
  justify-content: center;

  &.cells_mobile {
    .cells__item {
      margin: 15px;
    }
  }
  .cells__wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .cells__item {
    width: 20%;
    min-width: 350px;
    margin: 30px;
    border-radius: 6px;
    padding-top: 50px;
    display: flex;
    flex-direction: column;
  }
  .cells__header {
    height: 120px;
    min-height: 120px;
    background-color: #74819f;
    position: relative;
    padding-top: 40px;
    box-shadow: $cellShadow;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
  }
  .cells__title {
    height: 100%;
    color: #fff;
    font-size: 22px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cells__icon-wrap {
    width: 100%;
    position: absolute;
    top: -50px;
    display: flex;
    justify-content: center;
  }
  .cells__icon-block {
    width: 100px;
    height: 100px;
    background-color: #fff;
    border-radius: 50%;

    .v-icon {
      font-size: 60px;
      color: #fff;
    }
  }
  .cells__icon-circle {
    width: 90%;
    height: 90%;
    background-color: #d2dcf5;
    border-radius: 50%;
    margin: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cells__content {
    background-color: #d2dcf5;
    padding: 10px 20px;
    margin-top: 5px;
    flex: 1;
    box-shadow: $cellShadow;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    display: flex;
    align-items: center;
  }
  .cells__string {
    width: 100%;
    font-size: 17px;
    font-weight: 400;
    margin: 10px 0;
    color: #262f44;
  }
}
</style>